export enum ModalType {
  CONFIGURATION_MODAL,
  INFORMATION_MODAL,
  TRANSFORMER_MODAL
}
